var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#704cb6",
    viewBox: "0 0 256 256",
    id: "Flat",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M220.48486,151.46973a4.00212,4.00212,0,0,0-5.05175-2.63086A88.03132,88.03132,0,0,1,107.1748,40.51563a4.00144,4.00144,0,0,0-5.00537-4.99952A96.01383,96.01383,0,1,0,220.49463,153.793,4.00624,4.00624,0,0,0,220.48486,151.46973ZM128,216A88.01613,88.01613,0,0,1,97.82812,45.30664,96.02124,96.02124,0,0,0,210.69336,158.17188,88.28123,88.28123,0,0,1,128,216Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.6bbc2b6216093d62bc4c6bc74dfd72fe.svg";
export { ForwardRef as ReactComponent };